import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import { Form, Modal } from "@components";
import React, { useCallback, useContext, useEffect } from "react";
import { useHistory } from "react-router";
import { Actions } from "../../../../../../screens/request/components/actions";
import CloseIcon from "@material-ui/icons/Close";
import { Api } from "@api";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
// import { Employee } from "../../../../../../store";
import { Employee } from "@api";
import { FormData } from "./form";
import { useEmployeeStore } from "../../../../../../store/hooksy";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });
//
export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  id: 0;
  data: Employee | undefined;
  isOpen: boolean;
  onClickAdd: () => void;
  onClickClose: () => void;
  action: string;
}

type FormValues = {
  id: number;
  email: string;
  location: string;
  userNtLogin: string;
  managerEmail: string;
  vpemail: string;
  svpemail: string;
  secondManagerEmail: string;
  active: boolean;
  divestitureCode: string;
  networkId: string;
};

type Key = keyof FormValues;

export const EmployeeDetails: React.FC<Props> = ({
  id,
  data,
  isOpen,
  onClickAdd,
  onClickClose,
  action,
}) => {
  const [, setEmployeeStore] = useEmployeeStore();
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = React.useState<
    boolean
  >(false);
  const [pending, setPending] = React.useState(false);
  const initial_values = data;
  const [values, setValues] = React.useState<FormValues | undefined>(
    initial_values
  );
  const form = Form.useManager<FormValues>({
    id: 0,
    email: data ? data.email : "",
    location: data ? data.location : "",
    userNtLogin: data ? data.userNtLogin : "",
    managerEmail: data ? data.managerEmail : "",
    vpemail: data ? data.vpemail : "",
    svpemail: data ? data.svpemail : "",
    secondManagerEmail: data ? data.secondManagerEmail : "",
    active: data ? data.active : true,
    divestitureCode: data?.divestitureCode ? data.divestitureCode : "",
    networkId: data?.networkId ? data.networkId : "",
  });

  function onChange(name: Key, value: any): void {
    // console.log("test");
    form.set(Form.target.VALUE, [name, value]);
    validate([name, value]).then(([name, error]) => {
      form.set(Form.target.ERROR, [name, error]);
    });
  }

  function validate([name, value]: [string, any]): Promise<[Key, Error?]> {
    switch (name) {
      // case "userNtLogin":
      //   return Promise.resolve([
      //     name as Key,
      //     Form.Validators.hasValue(value),
      //   ]);
      // case "email":
      // case "managerEmail":
      //   return Promise.resolve([
      //     name as Key,
      //     Form.Validators.hasValue(value) || Form.Validators.isEmail(value),
      //   ]);
      // case "vpemail":
      // case "svpemail":
      // case "secondManagerEmail":
      //   if(value != null && value != ""){
      //     return Promise.resolve([name as Key, Form.Validators.isEmail(value)]);
      //   }
      default:
        return Promise.resolve([name as Key]);
    }
  }

  function handleAddButtonClick(): void {
    setPending(true);
    Api.employee
      .editEmployee(data ? data.id : id, {
        ...form.values,
      })
      .then(() => {
        setEmployeeStore({ employeeId: data?.id });
        setPending(false);
        setIsOpenConfirmationModal(false);
        form.reset();
        onClickClose();
        onClickAdd();
      })
      .catch((error) => {
        setPending(false);
        console.log("Error: Update Employee. " + error);
      });
  }

  function handleSubmitButtonClick(): void {
    Promise.all(Object.entries(form.values).map(validate)).then(
      (validations) => {
        const valid = validations.reduce((valid, [name, error]) => {
          return valid && !error;
        }, true);
        if (valid) {
          setIsOpenConfirmationModal(true);
        } else {
          validations.forEach(([name, error]) => {
            form.set(Form.target.ERROR, [name, error]);
          });
        }
      }
    );
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const clickCloseBtn = () => {
    setValues(undefined);
    form.reset();
    onClickClose();
  };

  const handleClose = () => {
    setOpen(false);
  };
  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  return (
    <Box mt={2} mb={2}>
      <Modal
        isOpen={isOpenConfirmationModal}
        positionButton="center"
        actions={[
          {
            label: "Cancel",
            variant: "outlined",
            handler: () => {
              setIsOpenConfirmationModal(false);
            },
          },
          {
            label: pending ? "Submitting..." : "Submit",
            handler: () => {
              handleAddButtonClick();
            },
            disabled: pending,
          },
        ]}
      >
        <Typography align="center" paragraph>
          Are you sure you want to update this Employee?
        </Typography>
      </Modal>

      <Dialog
        open={isOpen}
        onClose={clickCloseBtn}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle id="form-dialog-title" onClose={clickCloseBtn}>
          Update Employee: {data ? data.email : ""}
        </DialogTitle>
        <DialogContent>
          <FormData data={data} onHandleChange={onChange} form={form} />
        </DialogContent>
        <DialogActions>
          <Button onClick={clickCloseBtn} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmitButtonClick} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
